import { Component, Input, OnChanges, OnInit, SimpleChanges, ViewChild } from '@angular/core';
import { DireccionesPersonal } from '../../../../models/direcciones-personal';
import { DireccionesPersonalService } from '../../../../services/direcciones-personal.service';
import { IboxtoolsItem } from '../../../../models/iboxtools-item';
import { DireccionDetalleComponent } from '../direccion-detalle/direccion-detalle.component';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ErroresService } from '../../../../core/services/errores.service';
import { MatDialog } from '@angular/material/dialog';
import { DialogProcesandoComponent } from '../../../../components/shared/dialog-procesando/dialog-procesando.component';
import { DialogConfirmacionComponent } from '../../../../components/shared/dialog-confirmacion/dialog-confirmacion.component';
import { GruposLiquidacionService } from '../../../../services/gruposLiquidacion.service';
import { MomentSetService } from '../../../../core/services/moment-set.service';

@Component({
  selector: 'app-direcciones',
  templateUrl: './direcciones.component.html',
  styleUrls: ['./direcciones.component.css']
})
export class DireccionesComponent implements OnInit, OnChanges {
 
  @Input() personalId;
  @Input() fechaslist;
  @Input() gruposLiquidaciones;
  @Input() personal;
  disabledEditing: boolean;
  direccion: DireccionesPersonal;
  verDetalle: boolean = false;
  isEditing: boolean = false;
  permisoEdicion: boolean = false;
  habilitarFormDetalle: boolean = false;
  MensajeError: string;

  //Control ibox
  direccionesHistoryList: any;
  direccionesList: DireccionesPersonal[];
  toolboxEnabled: boolean = false;
  onlyNew: boolean = true;
  direcciones: DireccionesPersonal[];
  buscando: boolean;
  cortarRegistro: boolean = false;
  ingreso: any;
  desdeAnterior: boolean = false;

  public cargaCompleta: boolean = false;

  @ViewChild('ChildDireccionDetalle') direccionDetalle: DireccionDetalleComponent;

  constructor(private direccionesPersonalService: DireccionesPersonalService, 
              private dialog: MatDialog, 
              private erroresService: ErroresService, 
              private snackBar: MatSnackBar,
              private gruposLiquidacionService: GruposLiquidacionService,
              private momentService: MomentSetService) { }

  ngOnInit(): void
  {
    this.obtenerDirecciones(false);   

    this.verPermiso();
  }

  async verPermiso() : Promise<void>  {
    let permisos = localStorage.getItem("Permisos");
    if (permisos.includes("Editar Direcciones")) this.permisoEdicion = true;
  }

  obtenerDirecciones(agrupar)
  {
    this.buscando = true;
    this.direccionesPersonalService.getDirecciones(this.personalId, agrupar).subscribe(
      data =>
      {
        data.forEach((currentValue,index,arr) => {
          currentValue.desde = this.momentService.convertDateServer(currentValue.desde);
          currentValue.hasta = this.momentService.convertDateServer(currentValue.hasta);
        });

        this.direcciones = data;
        this.buscando = false;
        this.cargaCompleta = true;
      },
      error =>
      {
        this.cargaCompleta = true;
        this.buscando = false;
        console.log(error);
      }
    );
  }

  ngOnChanges(changes: SimpleChanges): void
  {
    //throw new Error("Method not implemented.");
  }  

  async OnVisualizarDetalle(direccion)
  {
    if (direccion.id != 0)
    {
      this.obtenerHistorial(direccion);
    }
    else
    {
      if (await this.verEstadoNomina())
      {
        this.verDetalle = true;
        this.direccion = direccion;
        this.habilitarEdicion();
      }
    }
  }

  async OnDeleteChange(event)
  {
    if (await this.validarEdicion(this.direccion))
    {
      this.MensajeError = "";
      let dialogRef = this.dialog.open(DialogConfirmacionComponent, {
        width: '400px',
      });

      dialogRef.componentInstance.mensaje = "¿Está seguro de eliminar?";

      dialogRef.afterClosed().subscribe(result =>
      {
        if (result != null && result)
        {
          let dialogProcesandoRef = this.dialog.open(DialogProcesandoComponent, {
            width: '400px'
          });
          dialogProcesandoRef.componentInstance.Mensaje = "Eliminando...";

          this.direccionesPersonalService.eliminar(this.direccion.id).subscribe(
            response =>
            {
              this.snackBar.open("Direccion eliminada correctamente.", "OK", { duration: 10000 });
              setTimeout(function ()
              {
                dialogProcesandoRef.close();
              });

              let direccion = this.direccionesList.filter(d => d.id != this.direccion.id)[0];
              if (direccion == undefined)
              {
                this.volverAtras();
              }

              this.obtenerHistorial(direccion);
            },
            error =>
            {
              if (error.status == 400)
              {
              }
              else
              {
                this.erroresService.MostrarErrorByStatus(error, "Error al eliminar");
              }
              dialogProcesandoRef.close();
            });
        }
      }); 
    }
  }

  OnBackChange()
  {
    this.volverAtras();
  }

  async OnEditChange()
  {
    if (await this.validarEdicion(this.direccion))
    {
      this.habilitarEdicion();
      var $this = this;
      setTimeout(function ()
      {
        $this.direccionDetalle.form.controls['desde'].disable();
        $this.direccionDetalle.form.controls['hasta'].disable();
      });
    }
  }

  OnPeriodChange(index: number)
  {
    let direccion = this.direccionesList.find(d => d.id == index);
    this.direccion = direccion;
    this.MensajeError = "";
  }

  OnCancelChange(e: boolean)
  {
    this.direccionDetalle.setearForm(this.direccion);
    this.deshabilitarEdicion();
  }

  OnSaveChange(e: boolean)
  {
    if (this.validarDatos())
    {
      let dialogProcesandoRef = this.dialog.open(DialogProcesandoComponent, {
        width: '400px'
      });
      dialogProcesandoRef.componentInstance.Mensaje = "Guardando...";

      let formulario = this.direccionDetalle.form.getRawValue();

      let datosDir: DireccionesPersonal = {
        id: formulario.id,
        personal: formulario.personal,
        desde: this.momentService.saveDateServer(formulario.desde, false),
        hasta: this.momentService.saveDateServer(formulario.hasta, false),
        clase: formulario.clase,
        calle: formulario.calle,
        nro: formulario.nro,
        piso: formulario.piso,
        dpto: formulario.dpto,
        localidad: formulario.localidad,
        codPos: formulario.codPos,
        pais: formulario.pais,
        provincia: formulario.provincia,
        telefono: formulario.telefono,
        observaciones: formulario.observaciones,
        coordenadas: ''
      };

      this.direccionesPersonalService.guardar(datosDir, this.cortarRegistro).subscribe(
        direccion =>
        {
          direccion.desde = this.momentService.convertDateServer(direccion.desde);
          direccion.hasta = this.momentService.convertDateServer(direccion.hasta);

          setTimeout(function ()
          {
            dialogProcesandoRef.close();
          });

          this.snackBar.open("Dirección guardada", "OK", { duration: 10000 });

          this.deshabilitarEdicion();

          this.obtenerHistorial(direccion);
          //TODO. Modificar la forma de obtener la fecha sin el TimeZone
          //direccion.desde = direccion.desde.replace('Z', '');
          this.direccionDetalle.setearForm(direccion);
        },
        error =>
        {
          dialogProcesandoRef.close();

          if (error.status == 400)
          {
            this.MensajeError = this.erroresService.MostrarError400(error);
          }
          else
          {
            this.erroresService.MostrarErrorByStatus(error, "Error al guardar");
          }
        });
    }   
  }
   
  async OnNewChange(e: boolean)
  {
    if (await this.verEstadoNomina())
    {
      this.habilitarEdicion();
      this.direccionDetalle.form.controls['id'].setValue(0);
      this.direccionDetalle.form.controls['hasta'].setValue(new Date("2999-12-31T23:59:59"));
    }
  }

  async OnCutChange(e: boolean)
  {
    if (await this.verEstadoNomina())
    {
      this.cortarRegistro = true;
      this.habilitarEdicion();

      var $this = this;
      setTimeout(function ()
      {
        $this.direccionDetalle.form.controls['hasta'].disable();
      });
    }
  }

  private deshabilitarEdicion()
  {
    this.MensajeError = "";
    this.disabledEditing = true;
    this.isEditing = false;
    this.habilitarFormDetalle = false;
    this.cortarRegistro = false;
  }

  private habilitarEdicion()
  {
    this.desdeAnterior = false;
    this.MensajeError = "";
    this.disabledEditing = false;
    this.isEditing = true;
    this.habilitarFormDetalle = true;
  }

  private volverAtras()
  {
    this.MensajeError = "";
    this.direccionesHistoryList = [];
    this.direccionesList = [];
    this.habilitarFormDetalle = false;
    this.verDetalle = false;
    this.obtenerDirecciones(false);
  }

  private obtenerHistorial(direccion: DireccionesPersonal)
  {
    this.direccionesPersonalService.getHistoryByClase(direccion.personal, direccion.clase).subscribe(
      direcciones =>
      {
        direcciones.forEach((currentValue,index,arr) => {
          currentValue.desde = this.momentService.convertDateServer(currentValue.desde);
          currentValue.hasta = this.momentService.convertDateServer(currentValue.hasta);
        });

        this.direccionesHistoryList = [];
        direcciones.forEach(d =>
        {
          let item = new IboxtoolsItem(d);
          this.direccionesHistoryList.push(item);
        });

        this.direccionesList = direcciones;
        this.verDetalle = true;
        this.direccion = direccion;
     },
     error =>
     {
        console.log(error);
     });
  }

  private validarDatos(): boolean
  {
    this.MensajeError = "";

    this.ingreso = this.fechaslist.find(d => d.claseFechaNavigation.codigo == "01");
    let desde = this.direccionDetalle.form.get("desde").value.toDateString();
    
    let fingreso = new Date(this.ingreso.desde).toDateString();
    this.desdeAnterior = false;
    if (Date.parse(desde) < Date.parse(fingreso))
    {
      this.desdeAnterior = true;
      this.direccionDetalle.form.get("desde").setErrors({'desdeAnterior': true });
    }
    

    if (this.direccionDetalle.form.valid)
    {
      return true;
    }
    else
    {
      this.direccionDetalle.form.markAllAsTouched();
      return false;
    }
  }

  private async verEstadoNomina() : Promise<boolean>
  {
    let estadoValido = true;
    this.gruposLiquidaciones = await this.gruposLiquidacionService.GetVigenteByPersonal(this.personalId).toPromise();
    if (this.gruposLiquidaciones.estadoActual == 1) {
      estadoValido = false;
      this.snackBar.open("Acción no válida durante el Cálculo de la Nómina. Actualice el registro de gestión.", "OK", { duration: 10000 });
    }
    return estadoValido;
  }

  private async validarEdicion(row) : Promise<boolean>
  {
    let edita = true;
    
    let estadoValido = await this.verEstadoNomina();
    if (estadoValido == false) edita = false;
    
    return edita;
  }
  
}

